// import api from '../index'
import axios from 'axios'

export async function getByZipcode(zipcode: string) {
  try {
    // const response = await api.get(`/addresses/${zipcode}`)
    const response: any = await axios.get(
      `https://viacep.com.br/ws/${zipcode}/json`
    )

    if (response.data.erro) throw Error('CEP não encontrado.')

    const { cep, logradouro, bairro, localidade, uf } = response.data

    return {
      state: uf,
      zipcode: cep,
      city: localidade,
      street: logradouro,
      neighborhood: bairro,
    }
  } catch (error) {
    throw error
  }
}
